import { GatsbyImageProps } from "gatsby-plugin-image"
import React, { FC, ReactNode } from "react"
import {
  ImageTenMonths,
  ImageZashita,
  ImageTenPercent,
  ImageFivePercent,
  ImageFourPercent,
} from "./images"

export interface ICard {
  id: number
  title: ReactNode
  Image: FC<Omit<GatsbyImageProps, "image">>
  alt: string
  tooltipText?: ReactNode
}

export const CARDS_DEFAULT: ICard[] = [
  {
    id: 1,
    title: (
      <>
        Увеличенная рассрочка* <b>от&nbsp;10 месяцев</b> у&nbsp;всех партнеров
      </>
    ),
    Image: ImageTenMonths,
    alt: "ten months",
    tooltipText: (
      <>
        Увеличенная рассрочка* у&nbsp;всех партнеров. Совершайте покупки у&nbsp;любых партнеров
        Халвы со&nbsp;сроком рассрочки* от&nbsp;10&nbsp;месяцев и&nbsp;больше.
      </>
    ),
  },
  {
    id: 2,
    title: (
      <>
        <b>Защита</b> покупок
      </>
    ),
    Image: ImageZashita,
    alt: "protection",
    tooltipText: (
      <>
        Автоматическая защита всех важных покупок и&nbsp;юридическая помощь по&nbsp;правам
        покупателей 24/7
      </>
    ),
  },
  {
    id: 3,
    title: (
      <>
        <b>До +5%</b> к ставке вклада
      </>
    ),
    Image: ImageFivePercent,
    alt: "five recent",
    tooltipText: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10&nbsp;покупок по&nbsp;Халве на&nbsp;общую
        сумму от&nbsp;20&nbsp;000&nbsp;₽. +2%&nbsp;годовых добавляется к&nbsp;ставке вклада,
        открытого на&nbsp;24&nbsp;мес., +5% для&nbsp;вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим
        срокам +1%).
      </>
    ),
  },
  {
    id: 4,
    title: (
      <>
        Кешбэк <b>до 10%</b>
      </>
    ),
    Image: ImageTenPercent,
    alt: "ten percent",
    tooltipText: (
      <>
        При оплате телефоном (с&nbsp;помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным
        стикером или в Интернете. В том числе гарантированный кэшбэк 10% за&nbsp;каждую поездку
        на&nbsp;такси «Яндекс Go».
      </>
    ),
  },
]

// кЕшбэк через Е
export const CARDS_DEFAULT_V2: ICard[] = [
  {
    id: 1,
    title: (
      <>
        Увеличенная рассрочка* <b>от&nbsp;10 месяцев</b> у&nbsp;всех партнеров
      </>
    ),
    Image: ImageTenMonths,
    alt: "ten months",
    tooltipText: (
      <>
        Увеличенная рассрочка* у&nbsp;всех партнеров. Совершайте покупки у&nbsp;любых партнеров
        Халвы со&nbsp;сроком рассрочки* от&nbsp;10&nbsp;месяцев и&nbsp;больше.
      </>
    ),
  },
  {
    id: 2,
    title: (
      <>
        <b>Защита</b> покупок
      </>
    ),
    Image: ImageZashita,
    alt: "protection",
    tooltipText: (
      <>
        Автоматическая защита всех важных покупок и&nbsp;юридическая помощь по&nbsp;правам
        покупателей 24/7
      </>
    ),
  },
  {
    id: 3,
    title: (
      <>
        <b>+5%</b> к ставке вклада
      </>
    ),
    Image: ImageFivePercent,
    alt: "five recent",
    tooltipText: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10&nbsp;покупок по&nbsp;Халве на&nbsp;общую
        сумму от&nbsp;20&nbsp;000&nbsp;₽. +2%&nbsp;годовых добавляется к&nbsp;ставке вклада,
        открытого на&nbsp;24&nbsp;мес., +5% для&nbsp;вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим
        срокам +1%).
      </>
    ),
  },
  {
    id: 4,
    title: (
      <>
        Кешбэк <b>до 10%</b>
      </>
    ),
    Image: ImageTenPercent,
    alt: "ten percent",
    tooltipText: (
      <>
        При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным
        стикером или в Интернете. В том числе гарантированный кэшбэк 10% за&nbsp;каждую поездку
        на&nbsp;такси «Яндекс Go».
      </>
    ),
  },
]

export const CARDS_INVITEFRIEND: ICard[] = [
  {
    id: 1,
    title: (
      <>
        Рассрочка* <b>от&nbsp;10 месяцев</b> у&nbsp;всех партнеров
      </>
    ),
    Image: ImageTenMonths,
    alt: "ten months",
    tooltipText: (
      <>
        Увеличенная рассрочка* у&nbsp;всех партнеров. Совершайте покупки у&nbsp;любых партнеров
        Халвы со&nbsp;сроком рассрочки* от&nbsp;10&nbsp;месяцев и&nbsp;больше.
      </>
    ),
  },
  {
    id: 2,
    title: (
      <>
        Подборки товаров <br />
        <b>с лучшей ценой</b>
      </>
    ),
    Image: ImageZashita,
    alt: "protection",
    tooltipText: (
      <>
        Ваша выгода за месяц может быть такой:
        <ul>
          <li>Кафе и продукты (30 000 ₽ × 5% кэшбэк) = 1 500 ₽</li>
          <li>АЗС (10 000 ₽ × 10% кэшбэк) = 1 000 ₽</li>
          <li>Такси (5 000 ₽ × 10% кэшбэк) = 500 ₽</li>
          <li>Минус стоимость подписки: 99 ₽</li>
          <li>
            <b>Ваша выгода за месяц: 2 901 ₽</b>
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 3,
    title: (
      <>
        <b>+5%</b> к ставке вклада
      </>
    ),
    Image: ImageFivePercent,
    alt: "five recent",
    tooltipText: (
      <>
        До +5% на остаток собственных средств первые три&nbsp;месяца при&nbsp;подключении подписки
        «Халва.Десятка».
      </>
    ),
  },
  {
    id: 4,
    title: (
      <>
        Кешбэк <b>до 10%</b>
      </>
    ),
    Image: ImageTenPercent,
    alt: "ten percent",
    tooltipText: (
      <>
        При оплате телефоном (с&nbsp;помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным
        стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку
        на&nbsp;такси «Яндекс Go».
      </>
    ),
  },
]

export const CARDS_HALVA_I_VKLAD: ICard[] = [
  {
    id: 1,
    title: (
      <>
        Кешбэк <b>до 10%</b>
      </>
    ),
    Image: ImageTenPercent,
    alt: "ten months",
    tooltipText: (
      <>
        10% кешбэка начисляется за&nbsp;оплату через интернет/сервисом Пэй/платежным стикером
        покупок у&nbsp;партнёров от&nbsp;10 000 руб. Без подписки размер кешбэка в&nbsp;два раза
        меньше.
      </>
    ),
  },
  {
    id: 2,
    title: (
      <>
        <b>Защита</b> покупок
      </>
    ),
    Image: ImageZashita,
    alt: "protection",
    tooltipText: (
      <>
        Автоматическая защита всех важных покупок и&nbsp;юридическая помощь по&nbsp;правам
        покупателей 24/7
      </>
    ),
  },
  {
    id: 3,
    title: (
      <>
        <b>До +5%</b> к ставке вклада
      </>
    ),
    Image: ImageFivePercent,
    alt: "five recent",
    tooltipText: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10&nbsp;покупок по&nbsp;Халве на&nbsp;общую
        сумму от&nbsp;20&nbsp;000&nbsp;₽. +2%&nbsp;годовых добавляется к&nbsp;ставке вклада,
        открытого на&nbsp;24&nbsp;мес., +5% для&nbsp;вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим
        срокам +1%).
      </>
    ),
  },
  {
    id: 4,
    title: (
      <>
        <b>Кешбэк 4%</b> за&nbsp;каждую покупку у&nbsp;партнера
      </>
    ),
    Image: ImageFourPercent,
    alt: "ten percent",
    tooltipText: (
      <>
        При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным
        стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси
        «Яндекс Go».
      </>
    ),
  },
]

export const CARDS_ZHKH: ICard[] = [
  {
    id: 1,
    title: (
      <>
        Увеличенная рассрочка* <b>от&nbsp;10 месяцев</b> у&nbsp;всех партнеров
      </>
    ),
    Image: ImageTenMonths,
    alt: "ten months",
    tooltipText: (
      <>
        Увеличенная рассрочка* у&nbsp;всех партнеров. Совершайте покупки у&nbsp;любых партнеров
        Халвы со&nbsp;сроком рассрочки* от&nbsp;10&nbsp;месяцев и&nbsp;больше.
      </>
    ),
  },
  {
    id: 2,
    title: (
      <>
        <b>Зелёная цена* на Ozon</b> <br />
        скидка до 30% <br />
        при оплате <br />
        любыми картами <br />
        Совкомбанка
      </>
    ),
    Image: ImageZashita,
    alt: "protection",
  },
  {
    id: 3,
    title: (
      <>
        <b>До +5%</b> к ставке вклада
      </>
    ),
    Image: ImageFivePercent,
    alt: "five recent",
    tooltipText: (
      <>
        При ежемесячном выполнении условия: от&nbsp;10&nbsp;покупок по&nbsp;Халве на&nbsp;общую
        сумму от&nbsp;20&nbsp;000&nbsp;₽. +2%&nbsp;годовых добавляется к&nbsp;ставке вклада,
        открытого на&nbsp;24&nbsp;мес., +5% для&nbsp;вклада на&nbsp;36&nbsp;мес. (по&nbsp;другим
        срокам +1%).
      </>
    ),
  },
  {
    id: 4,
    title: (
      <>
        Кешбэк <b>до 10%</b>
      </>
    ),
    Image: ImageTenPercent,
    alt: "ten percent",
    tooltipText: (
      <>
        При оплате телефоном (с помощью сервиса Пэй для Андроид / Айфоном для iOS), Платёжным
        стикером или в Интернете. В том числе гарантированный кешбэк 10% за каждую поездку на такси
        «Яндекс Go».
      </>
    ),
  },
]
